"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent } from "@/components/ui/card";
export default function WelcomeToOurTermsAndConditions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden bg-primary">
      {}
      <div className="absolute inset-0 bg-cover bg-center opacity-30" style={{
      backgroundImage: "url(/img/monochrome_city_skyline.png)"
    }} />

      {}
      <div ref={ref} className={`relative z-10 max-w-3xl mx-auto px-6 transition-all duration-[var(--duration-slow)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <Card className="card bg-secondary text-foreground-secondary shadow-strong border-2 border-transparent hover:border-white transition-all duration-[var(--duration-medium)]">
          <CardContent className="py-12 px-8">
            <h1 className="text-4xl md:text-5xl font-display font-bold mb-6 text-left">
              Welcome to Our Terms and Conditions
            </h1>
            <p className="text-lg text-foreground-light text-left leading-relaxed">
              Please take a moment to review the guidelines that govern your use of our services. 
              We are committed to transparency and ensuring you understand your rights and responsibilities 
              when engaging with our platform.
            </p>
          </CardContent>
        </Card>
      </div>
    </section>;
}